import React from "react";
import Wrapper from "../../hoc/Wrapper/Wrapper";
import BreadcrumbsTemp from "../../components/UI/BreadCrumb/BreadCrumbCustom";
import { Box, Grid } from "@material-ui/core";
import { client } from "../../service/ApolloClient/ApolloClient";
import { QUERY_USER } from "../../service/ApolloClient/ApolloQueries";
import { ErrorToast } from "../../hoc/ToastNotify/ToastNotify";
import { withRouter } from "react-router";
import PersonAddForm from "../../components/Person/Add/PersonAddForm";
import PersonListAttachment from "./PersonListAttachment";
import Loading from "../../components/UI/Loading/Loading";
import DebitCreditListUserPage from "../DebitCredit/DebitCreditListUserPage";
import BankAccountListUserPage from "../BankAccount/BankAccountListUserPage";
import PersonAmar from "./PersonAmar";
import DebitCreditRowDetail from "../../components/DebitCredit/RowDetail";
import ChequeSummaryTables from "../../components/Cheque/ChequeSummaryTables/ChequeSummaryTables";
import ChequeStatusCard from "../../components/Cheque/ChequeStatusCard/ChequeStatusCard";

export const PERSON_SELECT_EDIT = "PERSON_SELECT_EDIT";
export const PERSON_SELECT_ATTACHMENT = "PERSON_SELECT_ATTACHMENT";
export const PERSON_SELECT_CHEQUE_CONTRACT = "PERSON_SELECT_CHEQUE_CONTRACT";
export const PERSON_SELECT_CAR_CONTRACT = "PERSON_SELECT_CAR_CONTRACT";

class PersonEditPage extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      id: props.match.params.id,
      data: null,
      loading: true,
      pageSelect: PERSON_SELECT_EDIT,
      keyDebit: Math.random(),
      openDebit: null,
      keyRowDebit: Math.random(),
    };

    this.handleSelectPage = this.handleSelectPage.bind(this);
    this.handleReloadDebit = this.handleReloadDebit.bind(this);
  }

  componentDidMount() {
    this.loadPage();
  }

  componentDidUpdate(prevProps) {
    const id = this.props.match.params.id;
    if (id !== prevProps.match.params.id) {
      this.setState(
        {
          id,
          data: null,
          loading: true,
          pageSelect: PERSON_SELECT_EDIT,
        },
        () => this.loadPage(id),
      );
    }
  }

  handleSelectPage = (page) => {
    this.setState({
      pageSelect: page,
    });
  };

  loadPage = (id = this.state.id) => {
    this.setState({
      loading: true,
    });

    client
      .query({
        query: QUERY_USER,
        variables: {
          id: parseInt(id),
        },
        fetchPolicy: "network-only",
      })
      .then((res) => {
        if (String(this.props.match.params.id) !== String(id)) return;
        let data = res.data.user;

        this.setState({
          loading: false,
          data: data,
        });
      })
      .catch((err) => {
        if (String(this.props.match.params.id) !== String(id)) return;
        this.setState({
          loading: false,
          data: null,
        });
        ErrorToast("مشکل در دریافت اطلاعات");
      });
  };

  handleReloadDebit() {
    this.setState({
      keyDebit: Math.random(),
      keyRowDebit: Math.random(),
    });
  }

  render() {
    const { data, loading, pageSelect } = this.state;

    let componentSelect = <Loading />;

    if (pageSelect === PERSON_SELECT_EDIT && !loading) {
      componentSelect = (
        <Grid container={true}>
          <Grid item md={12}>
            <PersonAddForm
              handleSelectPage={this.handleSelectPage}
              data={data}
              handleReloadDebit={this.handleReloadDebit}
              isEdit={true}
              setOpenDebit={(e) => {
                this.setState({ openDebit: e });
              }}
            />
          </Grid>
          <Grid item md={12}>
            <Box mt={2} mb={2}>
              <ChequeStatusCard userId={data.id} key={`cheque-status-${data.id}`} />
            </Box>
          </Grid>
          <Grid item md={12}>
            <Box mt={2} mb={2}>
              <ChequeSummaryTables userId={data.id} key={`cheque-summary-${data.id}`} />
            </Box>
          </Grid>
          <Grid item md={12}>
            <Box mt={2} mb={2}>
              <DebitCreditRowDetail
                user={data.id}
                openDebit={this.state.openDebit}
                hideChequeStats={true}
                key={this.state.keyRowDebit}
              />
            </Box>
          </Grid>
          <Grid item md={12}>
            <Box mt={2} mb={2}>
              <DebitCreditListUserPage
                user_id={data.id}
                key={this.state.keyDebit}
                isPerson={true}
                pdfName={`بدهی و طلب ${this.state.data ? this.state.data.fullname : ''}`}
              />
            </Box>
          </Grid>
          <Grid item md={12}>
            <Box mt={2} mb={2}>
              <BankAccountListUserPage user_id={data.id} pdfName={`حساب بانکی ${this.state.data ? this.state.data.fullname : ''}`} />
            </Box>
          </Grid>

          <Grid item md={12}>
            <Box mt={2} mb={2}>
              <PersonAmar user={data.id} amar={data.cheque_amar} />
            </Box>
          </Grid>
        </Grid>
      );
    } else if (pageSelect === PERSON_SELECT_ATTACHMENT && !loading) {
      componentSelect = (
        <PersonListAttachment
          handleBack={() => {
            this.setState({
              pageSelect: PERSON_SELECT_EDIT,
            });
          }}
          user={data}
        />
      );
    }

    return (
      <Wrapper>
        <BreadcrumbsTemp
          title={"ویرایش کاربر"}
          items={[
            {
              title: "ویرایش کاربر ",
              to: "/person/list/",
            },
          ]}
        />

        <Grid container={true}>
          <Grid item xs={12}>
            {loading ? (
              <Loading />
            ) : data === null ? (
              <Wrapper>اطلاعاتی برای نمایش نیست</Wrapper>
            ) : (
              componentSelect
            )}
          </Grid>
        </Grid>
      </Wrapper>
    );
  }
}

export default withRouter(PersonEditPage);
